import { render, staticRenderFns } from "./DokumanForm.vue?vue&type=template&id=57a04bf2"
import script from "./DokumanForm.vue?vue&type=script&lang=ts"
export * from "./DokumanForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports